import React, { Component } from 'react';
import User from '../components/User/User';
import ReportSharingPanel from '../components/User/ReportSharingPanel';
import MultiplyHeader from '../components/MultiplyHeader/MultiplyHeader';
import { componentContainerStyle, componentContentStyle } from '../constants';
import { observer } from 'mobx-react';
import { Divider, Header } from 'semantic-ui-react';
import TutorialContext from '../pagesv2/Tutorial/TutorialContext';

const settingsButtonStyle = {
    padding: '10px 20px',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: "'Montserrat', sans-serif",
    color: '#ffffff',
    background: '#0784a7',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
};

export class UserProfile extends Component {
    render() {
        const { editUser, companyStore, currentUser } = this.props;
        return (
            <div style={componentContainerStyle}>
                <MultiplyHeader text="User Profile" />
                <div style={componentContentStyle}>
                    <div data-tour="settings-form">
                        <User {...this.props} />
                        <Divider section />
                        {editUser && companyStore?.company?.liveMeetingsEnabled && <ReportSharingPanel editUser={editUser} />}
                    </div>
                    {currentUser?.trainingPlanDismissedAt && (
                        <>
                            <Divider section />
                            <Header>Training Plan</Header>
                            <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '14px', color: '#666' }}>
                                You hid your Training Plan. Resume it to bring the daily guide back to your dashboard.
                            </p>
                            <button
                                onClick={() => currentUser.clearTrainingPlanDismissed().catch((err) => console.error('Failed to resume Training Plan:', err))}
                                style={settingsButtonStyle}
                            >
                                Resume Training Plan
                            </button>
                        </>
                    )}
                    <Divider section />
                    <Header>Tutorial</Header>
                    <TutorialContext.Consumer>
                        {({ restartTutorial }) => (
                            <button onClick={restartTutorial} style={settingsButtonStyle}>
                                Restart Tutorial
                            </button>
                        )}
                    </TutorialContext.Consumer>
                </div>
            </div>
        );
    }
}

export default observer(UserProfile);